// Privana-authored Safety presentation; tenant content is never a catalogue entry.
export default {
  "copy": {
    "accident": "Incidente",
    "nearMiss": "Vicino alla signorina",
    "propertyDamage": "Danni di proprietà",
    "memberComplaint": "Denunce dei soci",
    "safeguardingConcern": "Preoccupazioni di salvaguardia",
    "securityIncident": "Incidente di sicurezza",
    "vehicleIncident": "incidente stradale",
    "environmentalIncident": "Incidente ambientale",
    "other": "Altro",
    "low": "Basso",
    "medium": "Medio",
    "high": "Alto",
    "critical": "Critico",
    "open": "Apri",
    "investigating": "Investigazione",
    "awaitingAction": "Azione di risveglio",
    "closed": "Chiuso",
    "member": "Socio",
    "staff": "Personale",
    "contractor": "Contraente",
    "visitor": "Visitatore",
    "guest": "Ospite",
    "inProgress": "In corso",
    "completed": "Completato",
    "cancelled": "Annullato",
    "photo": "Fotografie",
    "document": "Documento",
    "witnessStatement": "Dichiarazione di testimone",
    "medical": "Medico medico",
    "clear": "Cancella",
    "searching": "Ricerca…",
    "noMatchesFound": "Nessun riscontro trovato.",
    "occurredTimeIn12HourFormat": "Tempo libero in formato 12 ore",
    "affectedPerson": "Persona colpita",
    "remove": "Rimuovi",
    "personType": "Tipo di persona",
    "affectedMember": "socio interessato",
    "searchMemberNameEmailOrNumber": "Nome del socio di ricerca, e-mail o numero",
    "affectedStaffMember": "Membro del personale interessato",
    "searchStaffNameOrEmail": "Cerca nome del personale o e-mail",
    "name": "Nome",
    "nameIfKnown": "Nome se noto",
    "roleInIncident": "Ruolo in incidente",
    "affectedPersonBystanderDriver": "Persona colpita, bystander, autista...",
    "treatmentGiven": "Trattamento dato",
    "firstAidNoneAmbulance": "Primo soccorso, nessuno, ambulanza...",
    "injuryNotes": "Note di infortunio",
    "injuryDetailsOrAffectedPersonNotes": "Dettagli lesioni o note persona colpita",
    "additionalNotes": "Note aggiuntive",
    "sentToHospital": "Inviato in ospedale",
    "addAShortTitleForTheIncident": "Aggiungi un breve titolo per l'incidente.",
    "addWhenTheIncidentHappened": "Aggiungi quando è successo l'incidente.",
    "unableToSaveIncident": "Incapace di salvare l'incidente.",
    "basicDetails": "Dettagli di base",
    "incidentType": "Tipo incidente",
    "severity": "Severità",
    "status": "Stato",
    "title": "Titolo",
    "eGSlipNearPoolSteps": "ad es. Slip vicino ai gradini della piscina",
    "occurredDateTime": "Data o ora",
    "location": "Luogo",
    "poolDeckKitchenCarPark": "Piscina coperta, cucina, parcheggio...",
    "areaDepartment": "Area/dipartimento",
    "leisureFBGrounds": "Tempo libero, F&B, Grounds...",
    "description": "Descrizione",
    "affectedPersonS": "Persona interessata(i)",
    "addAffectedPerson": "Aggiungere la persona interessata",
    "immediateAction": "Azione immediata",
    "firstAidAreaMadeSafeManagerNotified": "Primo soccorso, area resa sicura, manager notificato...",
    "investigation": "Investigazione",
    "investigationNotes": "Note di indagine",
    "rootCause": "Causa di radice",
    "correctiveActionSummary": "Riepilogo dell'azione correttiva",
    "cancel": "Annulla",
    "saving": "Salvataggio…",
    "saveIncident": "Salvare l'incidente",
    "addWitness": "Aggiungi un testimone",
    "searchMember": "socio della ricerca",
    "searchStaff": "Ricerca personale",
    "injuryDescriptionNotes": "Descrizione delle lesioni / note",
    "witnessType": "Tipo di testimone",
    "phone": "Telefono",
    "email": "E-mail",
    "statement": "Dichiarazione",
    "actionTitle": "Titolo dell'azione",
    "searchAssignee": "Assegnazione di ricerca",
    "actionDescription": "Descrizione dell'azione",
    "save": "Salva",
    "chooseAFileToUpload": "Scegli un file da caricare.",
    "unableToUploadAttachment": "Non è possibile caricare l'allegato.",
    "uploadAttachment": "Caricare l'allegato",
    "uploading": "Caricamento...",
    "upload": "Caricamento",
    "unableToLoadIncident": "Incapace di caricare l'incidente.",
    "unableToOpenAttachment": "Incapace di aprire l'allegato.",
    "unableToCloseIncident": "Incapace di chiudere l'incidente.",
    "loadingIncident": "Incidente di carico...",
    "backToIncidentLog": "Ritorno al registro degli incidenti",
    "edit": "Modifica",
    "closeIncident": "Chiuso incidente",
    "noDescriptionAddedYet": "Nessuna descrizione aggiunta ancora.",
    "locationLabel": "Posizione:",
    "area": "Zona:",
    "affectedPersonLabel": "Persona interessata:",
    "add": "Aggiungi",
    "noNotesAdded": "Nessuna nota aggiunta.",
    "noAffectedPeopleAddedYet": "Non sono ancora state aggiunte persone colpite.",
    "witnesses": "Testimoni",
    "noStatementAddedYet": "Non è stata ancora inserita alcuna dichiarazione.",
    "noWitnessesAddedYet": "Nessun testimone ha ancora aggiunto.",
    "followUpActions": "Azioni di seguito",
    "noDescription": "Nessuna descrizione.",
    "due": "Dovuto:",
    "noDate": "Nessun appuntamento",
    "markComplete": "Mark completo",
    "noFollowUpActionsYet": "Non ci sono ancora azioni da seguire.",
    "attachments": "Attacchi",
    "previewView": "Anteprima/Vista",
    "download": "Scarica",
    "linkedAttachment": "Attacco collegato",
    "noAttachmentsUploadedYet": "Non ci sono ancora allegati caricati.",
    "immediateActionLabel": "Azione immediata:",
    "investigationNotesLabel": "Note di indagine:",
    "rootCauseLabel": "Causa di radice:",
    "correctiveAction": "Azione correttiva:",
    "auditHistory": "Storia dell'audit",
    "readOnlyAuditEntry": "Entrata di audit di sola lettura",
    "noAuditEntriesYet": "Non c'e' ancora nessuna registrazione.",
    "closureNotesCorrectiveActionSummary": "Note di chiusura / sommario azione correttiva",
    "optionalNotesOrCorrectiveActionSummary": "Note opzionali o sintesi delle azioni correttive",
    "closing": "Chiusura...",
    "unableToLoadIncidents": "Incapace di caricare gli incidenti.",
    "editIncident": "Modifica dell'incidente",
    "newIncident": "Nuovo incidente",
    "openIncidents": "Incidenti aperti",
    "closedThisMonth": "Chiuso questo mese",
    "incidentLog": "Log incidentale",
    "newIncidentLabel": "Nuovo Incidente",
    "searchIncidents": "Incidenti di ricerca...",
    "allStatuses": "Tutti gli stati",
    "allTypes": "Tutti i tipi",
    "allSeverities": "Tutte le severità",
    "loadingIncidents": "Caricamento di incidenti...",
    "incidentNumber": "Numero d'incisione",
    "date": "Data",
    "type": "Tipo",
    "actions": "Azioni",
    "view": "Visualizza",
    "noIncidentsFound": "Nessun incidente trovato",
    "select": "Seleziona...",
    "search": "Cerca...",
    "firstAid": "Primo soccorso",
    "fireMarshal": "Marta di fuoco",
    "foodHygiene": "Igiene alimentare",
    "safeguarding": "Protezione della sicurezza",
    "poolPlant": "Pianta di piscina",
    "healthSafety": "Salute e sicurezza",
    "manualHandling": "Movimentazione manuale",
    "groundsMaintenance": "Manutenzione terreni",
    "pesticideApplication": "Applicazione di pesticidi",
    "machinery": "Macchine e macchinari",
    "insurance": "Assicurazione",
    "methodStatement": "Dichiarazione del metodo",
    "riskAssessment": "Valutazione del rischio",
    "custom": "Personalizzato",
    "active": "Attivo",
    "expiringSoon": "Scadenza a breve",
    "expired": "Scadenza",
    "missingExpiry": "Scadenza mancante",
    "archived": "Archiviato",
    "certificate": "Certificato",
    "addACertificationOrDocumentName": "Aggiungi una certificazione o un nome di documento.",
    "uploadsMustBe25MBOrSmaller": "I carichi devono essere 25MB o più piccoli.",
    "chooseAStaffMember": "Scegli un membro del personale.",
    "chooseOrCreateAContractor": "Scegliere o creare un appaltatore.",
    "addAHolderName": "Aggiungi un nome di supporto.",
    "unableToSaveCertification": "Incapace di salvare la certificazione.",
    "editCertification": "Modifica della certificazione",
    "addCertification": "Aggiungere la certificazione",
    "holder": "Titolare",
    "holderType": "Tipo di supporto",
    "staffMember": "Membro del personale",
    "searchStaffLabel": "Ricerca personale...",
    "searchContractors": "Appaltatori di ricerca...",
    "createContractor": "Creare appaltatori",
    "companyNameIfNotListed": "Nome della Società se non elencato",
    "holderName": "Nome del titolare",
    "nameOrOrganisation": "Nome o organizzazione",
    "certificationDetails": "Informazioni di certificazione",
    "certificationName": "Nome di certificazione",
    "eGEmergencyFirstAidAtWork": "ad es. Primo soccorso di emergenza al lavoro",
    "issuingBody": "Emissione del corpo",
    "trainingProviderOrAuthority": "Fornitore di formazione o autorità",
    "certificateNumber": "Numero di certificato",
    "issueDate": "Data di pubblicazione",
    "expiryDate": "Data di scadenza",
    "notes": "Note",
    "documents": "Documenti",
    "viewDownload": "Visualizza / Scarica",
    "attachmentType": "Tipo di allegato",
    "certificateUpload": "Caricamento certificato",
    "saveChanges": "Salva le modifiche",
    "certification": "Certificazione",
    "issuingBodyLabel": "Corpo di emissione",
    "expiryDateLabel": "Data di scadenza",
    "attachment": "Allegati",
    "noFile": "Nessun file",
    "archive": "Archivia",
    "unableToLoadCertifications": "Incapace di caricare le certificazioni.",
    "unableToArchiveCertification": "Incapace di archiviare la certificazione.",
    "totalCertifications": "Certificazioni totali",
    "expiringIn30Days": "Escursione in 30 giorni",
    "missingExpiryLabel": "Scadenza mancante",
    "contractorDocuments": "Documenti contrattuali",
    "certificationRegister": "Registro di certificazione",
    "addCertificationLabel": "Aggiungere la certificazione",
    "staffCertifications": "Certificazioni del personale",
    "contractorDocumentsLabel": "Documenti contrattuali",
    "documentLibrary": "Libreria dei documenti",
    "searchHolderCertificationIssuingBody": "Supporto di ricerca, certificazione, emissione corpo...",
    "allHolders": "Tutti i titolari",
    "loadingCertifications": "Certificazioni di caricamento...",
    "fileName": "Nome del file",
    "uploadDate": "Data di caricamento",
    "previewDownload": "Anteprima / Scarica",
    "noDocumentsUploadedYet": "Non ci sono ancora documenti caricati.",
    "noCertificationsAddedYet": "Non sono ancora state aggiunte certificazioni",
    "archiveCertification": "Certificazione dell'archivio",
    "archiving": "Archiviazione...",
    "fireSafety": "Sicurezza antincendio",
    "kitchen": "Cucina",
    "clubhouse": "Club",
    "golfCourse": "Campo da golf",
    "pool": "Piscina",
    "gym": "Palestra",
    "maintenance": "Manutenzione",
    "housekeeping": "Pulizia delle camere",
    "security": "Sicurezza",
    "general": "Generale",
    "adHoc": "Ad hoc",
    "daily": "Quotidiano",
    "weekly": "Settimanale",
    "monthly": "Mensile",
    "quarterly": "Trimestrale",
    "annually": "Annualmente",
    "text": "Testo",
    "number": "Numero",
    "signature": "Firma",
    "policy": "Politica",
    "procedure": "Procedura",
    "emergencyPlan": "Piano d'emergenza",
    "firePlan": "Piano di fuoco",
    "templates": "Modelli",
    "checklistRuns": "Lista di controllo Runs",
    "riskAssessments": "Valutazione del rischio",
    "complianceCalendar": "Calendario di conformità",
    "fireSafetyCheck": "Controllo di sicurezza antincendio",
    "firstAidKitCheck": "Controllo del kit di pronto soccorso",
    "kitchenOpeningCheck": "Cucina in apertura Check",
    "poolSafetyCheck": "Controllo di sicurezza della piscina",
    "golfCourseMachineryCheck": "Campo da golf Controllo macchinari",
    "clubhouseWalkthrough": "Visita della clubhouse",
    "pass": "Passaggio",
    "failed": "Non riuscito",
    "mixed": "Mista",
    "incomplete": "Incompleto",
    "inProgressLabel": "In corso",
    "overdue": "Scaduto",
    "moreActions": "Altre azioni",
    "selectedTeamMember": "Membro del team selezionato",
    "searchByNameOrEmail": "Ricerca per nome o e-mail",
    "noMatchingTeamMembers": "Nessun membro della squadra corrispondente.",
    "scheduledChecklist": "Elenco di controllo programmato",
    "dueLabel": "Dovuto",
    "runNow": "Correte ora",
    "openRun": "Aprire il percorso",
    "nothingHere": "Qui non c'e' niente.",
    "viewMore": "Ulteriori informazioni",
    "close": "Chiudi",
    "unableToSaveTemplate": "Non è possibile salvare il modello.",
    "editChecklistTemplate": "Modifica modello della lista di controllo",
    "createChecklistTemplate": "Crea il modello della lista di controllo",
    "templateName": "Nome del modello",
    "category": "Categoria",
    "areaDepartmentLabel": "Area / dipartimento",
    "frequency": "Frequenza",
    "defaultDueTime": "Tempo di scadenza predefinito",
    "hH": "H",
    "mM": "MM",
    "activeTemplate": "Modello attivo",
    "recurringSchedule": "Orari ricorrenti",
    "startDate": "Data di inizio",
    "endDateOptional": "Data d'arrivo opzionale",
    "createRunXDaysBeforeDue": "Creare eseguire X giorni prima del dovuto",
    "defaultAssignees": "Assegnazioni predefinite",
    "nextDuePreview": "Prossima anteprima:",
    "savedAfterTemplateIsCreatedOrUpdated": "Salvataggio dopo il modello viene creato o aggiornato.",
    "automaticSchedulingIsOff": "La programmazione automatica è spenta.",
    "checklistItems": "Elenco dei prodotti",
    "addItem": "Aggiungi l'articolo",
    "itemLabel": "Etichetta dell'oggetto",
    "helpText": "Aiuto testo",
    "response": "Risposta",
    "required": "Obbligatorio",
    "optional": "Facoltativo",
    "photoOnFail": "Foto su fallo",
    "noPhotoRule": "Nessuna regola foto",
    "saveTemplate": "Salva il modello",
    "unableToStartRun": "Incapace di iniziare a correre.",
    "runChecklist": "Esegui checklist",
    "template": "Modello",
    "selectTemplate": "Selezionare il modello",
    "assignTo": "Assegnare a",
    "dueDateTime": "Data / ora",
    "starting": "Cominciare...",
    "startRun": "Iniziare a correre",
    "noEvidenceUploadedYet": "Nessuna prova caricata.",
    "checklistRun": "Esecuzione della checklist",
    "loadingChecklistRun": "Caricamento checklist run...",
    "assignedTo": "Assegnata a:",
    "unassigned": "Non assegnato",
    "fail": "Fail.",
    "pending": "In attesa",
    "yes": "Sì",
    "no": "No",
    "evidence": "Prove",
    "completeRun": "Correre completamente",
    "editRiskAssessment": "Modifica della valutazione del rischio",
    "addRiskAssessment": "Aggiungere la valutazione del rischio",
    "areaLabel": "Settore",
    "owner": "Proprietario",
    "hazard": "Pericolo",
    "whoMayBeHarmed": "Chi può essere danneggiato",
    "controls": "Controlli",
    "likelihood15": "Sollecitudine (1-5)",
    "severity15": "Severità (1-5)",
    "riskScore": "Punteggio del rischio",
    "reviewDate": "Data della recensione",
    "furtherActionRequired": "Ulteriori azioni necessarie",
    "noDescriptionLabel": "Nessuna descrizione",
    "complete": "Completo",
    "noActionsAddedYet": "Non sono ancora state aggiunte azioni.",
    "dueDate": "Data di scadenza",
    "addAction": "Aggiungi azione",
    "uploadEvidence": "Prove di carico",
    "saveRiskAssessment": "Risparmiare la valutazione dei rischi",
    "uploadDocument": "Documento di caricamento",
    "version": "Versione",
    "file": "File",
    "unableToLoadSafetyChecklists": "Non è possibile caricare liste di controllo di sicurezza.",
    "dueThisWeek": "A causa di questa settimana",
    "dueThisMonth": "A causa di questo mese",
    "later": "Più tardi.",
    "archiveChecklistTemplate": "Archivio modello di lista di controllo",
    "archiveRiskAssessment": "Valutazione del rischio dell'archivio",
    "archiveSafetyDocument": "Documento di sicurezza dell'archivio",
    "unableToArchiveThisRecord": "Incapace di archiviare questo record.",
    "activeTemplates": "Modelli attivi",
    "completedThisMonth": "Completato questo mese",
    "overdueChecks": "Esecuzione dei controlli",
    "openRiskActions": "Azioni di rischio aperte",
    "docsDueReview": "Documenti da revisionare",
    "safetyChecklists": "Controlli di sicurezza",
    "createTemplate": "Crea il modello",
    "loadingOperationalSafetySystem": "Caricamento sistema di sicurezza operativo...",
    "searchTemplates": "Modelli di ricerca...",
    "allCategories": "Tutti i gruppi",
    "allFrequencies": "Tutte le frequenze",
    "activeOnly": "Solo attivo",
    "allTemplates": "Tutti i modelli",
    "archivedOnly": "Archiviato solo",
    "schedule": "Calendario",
    "nextDue": "Prossima scadenza",
    "items": "Articoli",
    "manual": "Manuale",
    "inactive": "Inattivo",
    "runChecklistLabel": "Eseguire la lista di controllo",
    "noChecklistTemplatesYet": "Nessun modello di lista di controllo ancora",
    "searchRuns": "La ricerca funziona...",
    "allResults": "Tutti i risultati",
    "runNumber": "Numero di esecuzione",
    "assignedToLabel": "Assegnato a",
    "result": "Risultato",
    "activeRisks": "Rischi attivi",
    "highRisk": "Rischio elevato",
    "reviewDue": "Recensione dovuta",
    "openActions": "Azioni aperte",
    "searchRisks": "Rischi di ricerca...",
    "allScores": "Tutti i punteggi",
    "highRiskOnly": "Solo ad alto rischio",
    "riskNumber": "Numero di rischio",
    "searchDocuments": "Ricerca documenti...",
    "documentType": "Tipo di documento",
    "preview": "Anteprima",
    "noSafetyDocumentsUploadedYet": "Nessun documento di sicurezza caricato ancora.",
    "archiveRecord": "Archivio record",
    "everythingLooksHealthy": "Sembra tutto sano.",
    "aFewItemsNeedAttention": "Alcuni oggetti hanno bisogno di attenzione.",
    "severalComplianceAreasNeedReview": "Diverse aree di conformità hanno bisogno di revisione.",
    "immediateSafetyAttentionRequired": "Attenzione immediata di sicurezza necessaria.",
    "unableToLoadSafetyDashboard": "Non è possibile caricare il cruscotto di sicurezza.",
    "dashboardCouldNotLoad": "Dashboard non poteva caricare",
    "retry": "Riprova",
    "safetyComplianceOverview": "Panoramica sulla conformità alla sicurezza",
    "criticalItems": "Oggetti critici",
    "needsAttention": "Necessità di attenzione",
    "refreshed": "Raffreddamento",
    "overallComplianceScore": "Punteggio di conformità generale",
    "overdueChecklists": "Liste di controllo in ritardo",
    "certsExpiring": "Certificazioni che espongono",
    "riskReviewsDue": "Rischio recensioni dovute",
    "policiesAndProcedures": "Politiche e procedure",
    "attentionRequired": "Attenzione richiesta",
    "noUrgentSafetyActions": "Nessuna azione urgente di sicurezza",
    "recentActivity": "Attività recenti",
    "noRecentSafetyActivityYet": "Non c'e' ancora nessuna attivita' di sicurezza recente.",
    "incidentBreakdown": "Ripartizione incisiva",
    "noIncidentsRecorded": "Nessun incidente registrato.",
    "checklistHealth": "Salute della lista di controllo",
    "passRate": "Tasso di passi",
    "certificationHealth": "Certificazione di salute",
    "valid": "Valido",
    "expiring": "Scadenza",
    "riskDocumentHealth": "Rischi e stato dei documenti",
    "highRisks": "Rischi elevati",
    "loadingDashboard": "Caricamento Dashboard...",
    "loadingIncidentLog": "Caricamento Incident Log...",
    "loadingCertificationsLabel": "Caricamento Certificazioni...",
    "loadingChecklists": "Caricamento liste di controllo...",
    "passFail": "Passare / fallire",
    "yesNo": "Sì / no",
    "criticalHighIncidents": "Incidenti critici / alti",
    "addFollowUpAction": "Aggiungere l'azione di follow-up",
    "noExpiryRecorded": "Nessuna scadenza registrata",
    "expiresToday": "Scade oggi",
    "healthy": "Salute",
    "atRisk": "A rischio",
    "noDateSet": "Nessuna data impostata",
    "affectedPersonNumber": "Persona colpita {number}",
    "existingAffectedPersonNumber": "Persona colpita {number} (esistente)",
    "removeAssignee": "Rimuovi {name}",
    "assignee": "Assegnare",
    "openCertificationActions": "Azioni aperte per {name}",
    "showingCalendarItems": "Mostrando 3 di {count}",
    "calendarItemsOne": "{count} articolo ordinato dal più recente.",
    "calendarItemsOther": "{count} articoli ordinati dal più recente.",
    "dueOn": "A causa di {date}",
    "actionDescriptionDue": "{description} · dovuto {date}",
    "nextDueOn": "Successivo {date}",
    "runDescription": "{template} · {category} · Scadenza {date}",
    "assignedToNames": "Assegnata a: {names}",
    "assignedCount": "{count} assegnati",
    "openActionCount": "{count} aperto",
    "automaticFrequency": "{frequency} · Auto",
    "starterExamples": "Inizia con esempi di club-friendly come Fire Safety Check, First Aid Kit Check, Kitchen Opening Check, Pool Safety Check, Golf Course Machinery Check, Clubhouse Walkthrough.",
    "expiryOverdueOne": "{count} giorno in ritardo",
    "expiryOverdueOther": "{count} giorni in ritardo",
    "expiryRemainingOne": "{count} giorno rimanente",
    "expiryRemainingOther": "{count} giorni rimanenti",
    "highCriticalCount": "{count} alta/critica",
    "dueInSevenDays": "{count} dovuto in 7 giorni",
    "expiredCount": "{count} scaduto",
    "riskActionCounts": "{high} alto · {actions} azioni",
    "activity": "Attività di sicurezza",
    "certificationExpires": "{name} · Scade {date}",
    "moreCertifications": "+ {count} più",
    "moveItemUp": "Spostare l'oggetto in su",
    "moveItemDown": "Spostare l'oggetto in basso",
    "dateFrom": "A partire da",
    "dateTo": "Ad oggi",
    "cancelForm": "Annullare il modulo",
    "slipTripOrFall": "Slip, viaggio o autunno",
    "cutOrLaceration": "Taglio o lacerazione",
    "burn": "Bruciare",
    "allergicReaction": "Reazione allergica",
    "foodPoisoning": "Avvelenamento alimentare",
    "equipmentRelatedInjury": "Equipaggiamento-relato infortunio",
    "drowningNearDrowning": "Drowing/Near Drowning",
    "fire": "Fuoco",
    "flood": "Inondazione",
    "gasLeak": "Leghe di gas",
    "powerOutage": "Estrazione di energia",
    "structuralDamage": "Danni strutturali",
    "chemicalSpill": "Spillaggio chimico",
    "securityBreach": "Sicurezza Breach",
    "theft": "Furto",
    "vandalism": "Vandalismo",
    "minorNoMedicalAttentionRequired": "Minore - Nessuna attenzione medica richiesta",
    "moderateFirstAidAdministered": "Moderatore - Primo soccorso somministrato",
    "seriousMedicalAttentionRequired": "Serious - Prestazioni mediche",
    "criticalEmergencyServicesCalled": "Critical - Servizi di emergenza chiamati",
    "updateSafetyIncidentReport": "Relazione sulla sicurezza di aggiornamento",
    "newSafetyIncidentReport": "Nuova Relazione sull'incidenza sulla sicurezza",
    "typeOfIncident": "Tipo di Incidente *",
    "severityLevel": "Livello di gravità *",
    "locationOfIncident": "Posizione di Incident *",
    "eGPoolDeckMainDiningRoomTennisCourt1": "ad esempio, Piscina coperta, Sala da pranzo principale, Campo da tennis 1",
    "detailedDescription": "Descrizione dettagliata *",
    "describeWhatHappenedHowItHappenedAndAnyContributingFactors": "Descrivi ciò che è successo, come è successo, e tutti i fattori che contribuiscono...",
    "injuredAffectedPerson": "Infortunio/persona interessata",
    "fullNameOfInjuredPerson": "Nome completo della persona ferita",
    "personTypeLegacy": "Tipo di persona",
    "clubMember": "socio del Club",
    "memberGuest": "Ospite socio",
    "staffMemberLegacy": "Membro del personale *",
    "enterWitnessName": "Inserisci il nome del testimone",
    "immediateActionTaken": "Azione immediata presa *",
    "describeTheImmediateResponseFirstAidGivenAreaSecuredEtc": "Descrivere la risposta immediata, il primo soccorso dato, l'area protetta, ecc.",
    "medicalAttentionRequired": "Attenzione medica richiesta",
    "emergencyServicesCalled": "Servizi di emergenza chiamati",
    "reportedToAuthorities": "Rapporti con le autorità",
    "photosTakenOfScene": "Foto scattate dalla scena",
    "followUpActionRequired": "Azione di follow-up richiesta",
    "updateReport": "Relazione sull'aggiornamento",
    "submitIncidentReport": "Inviare Relazione Incidentale",
    "cPRCardiopulmonaryResuscitation": "CPR (Resuscitazione Cardopolmonare)",
    "firstAidLegacy": "Primo soccorso",
    "aEDAutomatedExternalDefibrillator": "AED ( defibrillatore esterno automatizzato)",
    "lifeguardCertification": "Certificazione di protezione della vita",
    "waterSafetyInstructor": "Istruttore di sicurezza dell'acqua",
    "poolOperatorCertification": "Certificazione dell'operatore del pool",
    "foodSafetyServSafe": "Sicurezza alimentare/ServSafe",
    "foodHandlerCertificate": "Certificato del manubrio del cibo",
    "allergenAwareness": "Consapevolezza di allergeni",
    "fireSafetyTraining": "Formazione di sicurezza antincendio",
    "fireExtinguisherTraining": "Allenamento dell'estintore di fuoco",
    "emergencyResponseTraining": "Formazione di risposta alle emergenze",
    "workplaceSafetyOSHA": "Sicurezza del posto di lavoro (OSHA)",
    "hazardousMaterialsHandling": "Materiali pericolosi Handling",
    "chemicalSafetyTraining": "Formazione di sicurezza chimica",
    "electricalSafety": "Sicurezza elettrica",
    "forkliftOperation": "Funzionamento del carrello elevatore",
    "defensiveDriving": "Guida difensiva",
    "securityTraining": "Formazione di sicurezza",
    "incidentCommandSystemICS": "Sistema di Comando Incident (ICS)",
    "bloodbornePathogensTraining": "Formazione degli agenti patogeni nel sangue",
    "confinedSpaceEntry": "Entrata spaziale confusa",
    "fallProtection": "Protezione delle cadute",
    "personalProtectiveEquipmentPPE": "Apparecchiature di protezione individuale (PPE)",
    "riskAssessmentLegacy": "Valutazione del rischio",
    "emergencyActionPlanTraining": "Formazione del piano d'azione di emergenza",
    "evacuationProcedures": "Procedure di valutazione",
    "childProtectionSafeguarding": "Protezione dei bambini / Protezione dei bambini",
    "mentalHealthFirstAid": "Salute mentale Primo soccorso",
    "wildernessFirstAid": "Wilderness Primo soccorso",
    "localFireDepartment": "Dipartimento antincendio locale",
    "localHealthDepartment": "Dipartimento della sanità locale",
    "stateCertificationBoard": "Ente pubblico di certificazione",
    "professionalAssociation": "Associazione professionale",
    "trainingCompany": "Società di formazione",
    "updateStaffCertification": "Aggiornamento della certificazione del personale",
    "addStaffCertification": "Aggiungere la certificazione del personale",
    "enterStaffMemberName": "Inserisci il nome del membro del personale",
    "certificationType": "Tipo di certificazione *",
    "selectCertificationType": "Selezionare il tipo di certificazione",
    "issuingOrganization": "Organizzazione di emissione *",
    "selectIssuingOrganization": "Selezionare l'organizzazione di emissione",
    "issueDateLegacy": "Data di pubblicazione *",
    "expiryDateLegacy": "Data di scadenza *",
    "certificateDocument": "Documento di certificato",
    "clickToUploadCertificateOrDragAndDrop": "Fare clic per caricare il certificato o trascinare e rilasciare",
    "pDFJPGPNGUpTo10MB": "PDF, JPG, PNG fino a 10MB",
    "certificateUploaded": "✓ Certificato caricato: {file}",
    "updateCertification": "Certificazione di aggiornamento",
    "staffMemberTitle": "Membro del personale",
    "highCriticalOne": "{count} alta/critica",
    "highCriticalOther": "{count} alta/critica",
    "dueSevenOne": "{count} dovuto in 7 giorni",
    "dueSevenOther": "{count} dovuto in 7 giorni",
    "expiredOne": "{count} scaduto",
    "expiredOther": "{count} scaduto",
    "openActionOne": "{count} aperto",
    "openActionOther": "{count} aperto",
    "assignedOne": "{count} assegnati",
    "assignedOther": "{count} assegnati",
    "riskActionOneOne": "{high} alto · {actions} azioni",
    "riskActionOneOther": "{high} alto · {actions} azioni",
    "riskActionOtherOne": "{high} alto · {actions} azioni",
    "riskActionOtherOther": "{high} alto · {actions} azioni",
    "affectedPeopleHelp": "Aggiungi ogni membro, membro del personale, ospite, visitatore, appaltatore, o altra persona interessata dall'incidente.",
    "incidentDescriptionPlaceholder": "Che è successo? Mantenere il fatto e il club-friendly.",
    "attachmentUploadHelp": "Immagini, PDF, documenti di Word, file di testo e CSV file fino a 25MB sono supportati.",
    "closeIncidentConfirmation": "Chiudere questo incidente? Si può ancora vedere la storia del record e dell'audit.",
    "incidentFormHelp": "Catturare gli elementi essenziali ora; le note di indagine e il follow-up possono crescere nel tempo.",
    "incidentRegisterHelp": "Un libro sicuro di incidenti del club per gli incidenti, vicino a misses, azioni di follow-up, e la storia di audit.",
    "incidentEmptyHelp": "Prova a cancellare i filtri, o creare il primo incidente quando qualcosa ha bisogno di registrazione.",
    "certificationFormHelp": "Mantenere le qualifiche del personale e i documenti di conformità del committente in un unico registro sicuro.",
    "renewalNotesPlaceholder": "Note di rinnovo utili, restrizioni o controlli di prova.",
    "certificateUploadHelp": "Accettato: immagini, PDF, documenti di Word, testo e CSV file fino a 25MB. I file vengono memorizzati privatamente e aperti con link firmati.",
    "certificationRegisterHelp": "Tracciare il primo soccorso, il fuoco palude, l'igiene alimentare, salvaguardare, DBS, assicurazione contraente, RAMS e altri record di conformità.",
    "archiveCertificationConfirmation": "Archiviare questa certificazione? Sarà nascosto dalle opinioni attive di conformità, ma mantenuto per la storia dell'audit.",
    "templateFormHelp": "Costruire un controllo di sicurezza del club ripetibile con campi di risposta pratici e regole di prova.",
    "recurringReminderHelp": "Il personale assegnato riceverà una e-mail e Privana notifica 24 ore prima che ogni esecuzione programmata sia dovuta.",
    "adHocScheduleHelp": "I modelli ad hoc vengono eseguiti solo manualmente. Scegliere Daily, Weekly, Monthly, Quarterly o Annually per abilitare la pianificazione automatica.",
    "startRunHelp": "Selezionare un modello, assegna e la data di scadenza per questo controllo.",
    "riskFormHelp": "Catturare il rischio, controlli e rivedere il ritmo in lingua normale.",
    "documentStorageHelp": "Archiviazione di documenti privati con anteprima firmata e link di download.",
    "checklistRegisterHelp": "Modelli, controlli dal vivo, recensioni dei rischi, documenti e le prossime date di conformità per il tuo club.",
    "archiveRecordHelp": "Questo lo nasconderà da opinioni attive, ma conservarlo per la storia dell'audit.",
    "dashboardUpToDateHelp": "I vostri incidenti, certificazioni, checklist corre, rischi e documenti sono attualmente aggiornati.",
    "dbs": "DBS",
    "coshh": "COSHHH",
    "rams": "RAMS",
    "cctv": "TV a schermo piatto",
    "teamMember": "Membro del team",
    "memberNumber": "Iscritto{number}"
  },
  "enums": {
    "accident": "Incidente",
    "near_miss": "Vicino alla signorina",
    "property_damage": "Danni di proprietà",
    "member_complaint": "Denunce dei soci",
    "safeguarding_concern": "Preoccupazioni di salvaguardia",
    "security_incident": "Incidente di sicurezza",
    "vehicle_incident": "incidente stradale",
    "environmental_incident": "Incidente ambientale",
    "other": "Altro",
    "low": "Basso",
    "medium": "Medio",
    "high": "Alto",
    "critical": "Critico",
    "open": "Apri",
    "investigating": "Investigazione",
    "awaiting_action": "Azione di risveglio",
    "closed": "Chiuso",
    "member": "Socio",
    "staff": "Personale",
    "contractor": "Contraente",
    "visitor": "Visitatore",
    "guest": "Ospite",
    "in_progress": "In corso",
    "completed": "Completato",
    "cancelled": "Annullato",
    "photo": "Fotografie",
    "document": "Documento",
    "witness_statement": "Dichiarazione di testimone",
    "medical": "Medico medico",
    "cctv": "TV a schermo piatto",
    "first_aid": "Primo soccorso",
    "fire_marshal": "Marta di fuoco",
    "food_hygiene": "Igiene alimentare",
    "safeguarding": "Protezione della sicurezza",
    "dbs": "DBS",
    "pool_plant": "Pianta di piscina",
    "health_safety": "Salute e sicurezza",
    "coshh": "COSHHH",
    "manual_handling": "Movimentazione manuale",
    "grounds_maintenance": "Manutenzione terreni",
    "pesticide_application": "Applicazione di pesticidi",
    "machinery": "Macchine e macchinari",
    "insurance": "Assicurazione",
    "rams": "RAMS",
    "method_statement": "Dichiarazione del metodo",
    "risk_assessment": "Valutazione del rischio",
    "custom": "Personalizzato",
    "valid": "Attivo",
    "expiring_soon": "Scadenza a breve",
    "expired": "Scadenza",
    "missing_expiry": "Scadenza mancante",
    "archived": "Archiviato",
    "certificate": "Certificato",
    "fire_safety": "Sicurezza antincendio",
    "kitchen": "Cucina",
    "clubhouse": "Club",
    "golf_course": "Campo da golf",
    "pool": "Piscina",
    "gym": "Palestra",
    "maintenance": "Manutenzione",
    "housekeeping": "Pulizia delle camere",
    "security": "Sicurezza",
    "general": "Generale",
    "ad_hoc": "Ad hoc",
    "daily": "Quotidiano",
    "weekly": "Settimanale",
    "monthly": "Mensile",
    "quarterly": "Trimestrale",
    "annually": "Annualmente",
    "text": "Testo",
    "number": "Numero",
    "signature": "Firma",
    "policy": "Politica",
    "procedure": "Procedura",
    "emergency_plan": "Piano d'emergenza",
    "fire_plan": "Piano di fuoco",
    "templates": "Modelli",
    "runs": "Lista di controllo Runs",
    "risks": "Valutazione del rischio",
    "documents": "Documenti",
    "calendar": "Calendario di conformità",
    "draft": "Progetto",
    "review_due": "recensione dovuta",
    "scheduled_checklist": "Elenco di controllo programmato",
    "checklist_run": "esecuzione della checklist",
    "checklist": "Lista di controllo",
    "incident": "Incidente",
    "risk": "Rischio",
    "safety_document": "Documento di sicurezza",
    "evidence": "prove di prova",
    "inactive": "inattivo",
    "blocked": "bloccato"
  },
  "audit": {
    "incident_created": "incidente creato",
    "incident_updated": "incidente aggiornato",
    "incident_closed": "incidente chiuso",
    "certification_created": "certificazione creata",
    "certification_updated": "certificazione aggiornata",
    "certification_archived": "certificazione archiviata",
    "person_added": "persona aggiunto",
    "person_updated": "persona aggiornata",
    "person_removed": "persona rimossa",
    "witness_added": "testimone aggiunto",
    "witness_updated": "testimone aggiornato",
    "witness_removed": "testimone rimosso",
    "action_added": "azione aggiunta",
    "action_updated": "azione aggiornata",
    "action_cancelled": "azione annullata",
    "attachment_added": "allegato aggiunto",
    "attachment_uploaded": "allegato caricato",
    "attachment_removed": "allegato rimosso",
    "created": "creato",
    "updated": "aggiornato",
    "archived": "archiviato",
    "cancelled": "annullata",
    "completed": "completato",
    "item_added": "Articolo aggiunto",
    "item_updated": "articolo aggiornato",
    "item_removed": "elemento rimosso",
    "item_completed": "Articolo completato",
    "schedule_recalculated": "programma ricalcolato",
    "scheduled_run_created": "esecuzione programmata creata"
  },
  "errors": {
    "unknown": "Non è possibile completare questa richiesta di sicurezza. Si prega di riprovare.",
    "server_error": "Non è possibile completare questa richiesta di sicurezza. Si prega di riprovare.",
    "validation_error": "Si prega di controllare i campi, le date, i punteggi e le prove richieste prima di continuare.",
    "not_found": "Questo record di sicurezza o file non è più disponibile.",
    "run_locked": "L'esecuzione di questa lista di controllo è in sola lettura. Le piste completate o cancellate non possono essere modificate.",
    "invalid_upload": "Selezionare un file valido da caricare.",
    "file_too_large": "I file di aggancio devono essere 25MB o più piccoli.",
    "unsupported_file_type": "Carica un'immagine, PDF , documento di Word, file di testo, o CSV .",
    "upload_storage_unavailable": "L'archiviazione degli allegati di sicurezza non è disponibile. Si prega di contattare il supporto.",
    "unauthorized": "Accedi per accedere alla Sicurezza.",
    "forbidden": "Non hai il permesso di eseguire questa azione di sicurezza.",
    "timeout": "La richiesta di sicurezza è pronta. Si prega di riprovare.",
    "network_error": "Non è possibile connettersi alla Sicurezza. Controllare la connessione e riprovare.",
    "invalid_json": "La risposta di sicurezza non poteva essere letta. Si prega di riprovare."
  },
  "generated": {
    "overdueChecklist": "Elenco di controllo in ritardo: {name}",
    "expiredCertification": "Certificazione scaduta: {name}",
    "riskReviewDue": "Recensione del rischio dovuta: {name}",
    "documentReviewDue": "Recensione del documento dovuta: {name}",
    "checklistDueSoon": "Checklist a breve: {name}",
    "certificationExpiresSoon": "La certificazione scade a breve: {name}",
    "incidentSeverity": "{severity} gravitÃ incidente aperto",
    "viewIncident": "Visualizza l'incidente",
    "reviewCertificate": "Certificato di revisione",
    "reviewRisk": "Rischio di valutazione",
    "reviewDocument": "Documento di revisione",
    "openCalendar": "Calendario aperto",
    "openRun": "Aprire il percorso",
    "incidentUpdated": "Aggiornamento dell'incidenza",
    "certificationUpdated": "Certificazione aggiornata",
    "safetyItemUpdated": "Elemento di sicurezza aggiornato",
    "activity_incident_created_incident": "Incident Creato incidente",
    "activity_incident_updated_incident": "Incidente Aggiornato incidente",
    "activity_incident_closed_incident": "Incidente incidente chiuso",
    "activity_certification_created_incident": "Certificazione incidente creato",
    "activity_certification_updated_incident": "Certificazione incidente aggiornato",
    "activity_certification_archived_incident": "Certificazione incidente archiviato",
    "activity_person_added_incident": "Persona Aggiunta incidente",
    "activity_person_updated_incident": "Intervento aggiornato della persona",
    "activity_person_removed_incident": "Rimozione dell'incidente",
    "activity_witness_added_incident": "Witness Aggiunto incidente",
    "activity_witness_updated_incident": "Testimonianza incidente aggiornato",
    "activity_witness_removed_incident": "Testimonianza Rimosso incidente",
    "activity_action_added_incident": "Azione Aggiunta incidente",
    "activity_action_updated_incident": "Azione incidente aggiornato",
    "activity_action_cancelled_incident": "Azione annullata incidente",
    "activity_attachment_added_incident": "Attaccamento Aggiunto incidente",
    "activity_attachment_uploaded_incident": "Attaccamento Ricaricato incidente",
    "activity_attachment_removed_incident": "Attaccamento Rimosso incidente",
    "activity_created_incident": "Incidente creato",
    "activity_updated_incident": "Effetto aggiornato",
    "activity_archived_incident": "Discussione archiviata",
    "activity_cancelled_incident": "Annullamento dell'incidente",
    "activity_completed_incident": "Incidente completo",
    "activity_item_added_incident": "Articolo aggiunto incidente",
    "activity_item_updated_incident": "Articolo incidente aggiornato",
    "activity_item_removed_incident": "Articolo Rimosso incidente",
    "activity_item_completed_incident": "Articolo Incidente completo",
    "activity_schedule_recalculated_incident": "Calendario Ricalcolato incidente",
    "activity_scheduled_run_created_incident": "Esercizio programmato Esegui incidente creato",
    "activity_incident_created_certification": "Certificazione Incident Created",
    "activity_incident_updated_certification": "Certificazione aggiornata dell'incidente",
    "activity_incident_closed_certification": "Incident Certificazioni chiuse",
    "activity_certification_created_certification": "Certificazione Certificazioni Creata",
    "activity_certification_updated_certification": "Certificazione Certificazione Certificazione Aggiornata",
    "activity_certification_archived_certification": "Certificazione Certificazione Certificazioni Archiviate",
    "activity_person_added_certification": "Certificazione aggiunta alla persona",
    "activity_person_updated_certification": "Certificato di aggiornamento della persona",
    "activity_person_removed_certification": "Persona di certificazione eliminata",
    "activity_witness_added_certification": "Witness Aggiunto certificazione",
    "activity_witness_updated_certification": "Witness Certificazione aggiornata",
    "activity_witness_removed_certification": "Witness Certificazione eliminata",
    "activity_action_added_certification": "Azione Aggiunta certificazione",
    "activity_action_updated_certification": "Azione Certificazione aggiornata",
    "activity_action_cancelled_certification": "Certificazione cancellata di azione",
    "activity_attachment_added_certification": "Attaccamento Aggiunto certificazione",
    "activity_attachment_uploaded_certification": "Attaccamento Certificazione caricata",
    "activity_attachment_removed_certification": "Attaccamento Certificazione eliminata",
    "activity_created_certification": "Certificazioni create",
    "activity_updated_certification": "Certificazione aggiornata",
    "activity_archived_certification": "Certificazione archiviata",
    "activity_cancelled_certification": "Certificazione cancellata",
    "activity_completed_certification": "Certificazione completa",
    "activity_item_added_certification": "Oggetto Certificazione aggiuntiva",
    "activity_item_updated_certification": "Voce Certificazione aggiornata",
    "activity_item_removed_certification": "Oggetto Certificazione eliminata",
    "activity_item_completed_certification": "Oggetto Certificazione completa",
    "activity_schedule_recalculated_certification": "Programma Certificazioni Recalcolate",
    "activity_scheduled_run_created_certification": "Esegui la certificazione Creata",
    "activity_incident_created_checklist_run": "Incidente creato checklist run",
    "activity_incident_updated_checklist_run": "Correre la lista di controllo aggiornata dell'incidente",
    "activity_incident_closed_checklist_run": "Incident Chiuso checklist run",
    "activity_certification_created_checklist_run": "Certificazione Creato checklist run",
    "activity_certification_updated_checklist_run": "Certificazione Esegui checklist aggiornato",
    "activity_certification_archived_checklist_run": "Certificazione Archiviato checklist run",
    "activity_person_added_checklist_run": "Persona Aggiunta checklist run",
    "activity_person_updated_checklist_run": "Persona Aggiornata lista di controllo",
    "activity_person_removed_checklist_run": "Persona Rimossa checklist run",
    "activity_witness_added_checklist_run": "Witness Aggiunto checklist run",
    "activity_witness_updated_checklist_run": "Witness Aggiornato checklist run",
    "activity_witness_removed_checklist_run": "Witness Rimozione della lista di controllo",
    "activity_action_added_checklist_run": "Azione Aggiunta checklist run",
    "activity_action_updated_checklist_run": "Azione Aggiornato checklist run",
    "activity_action_cancelled_checklist_run": "Azione Cancellata checklist run",
    "activity_attachment_added_checklist_run": "Attaccamento Aggiunto checklist run",
    "activity_attachment_uploaded_checklist_run": "Correre la lista di controllo caricata",
    "activity_attachment_removed_checklist_run": "Attaccamento Rimosso checklist run",
    "activity_created_checklist_run": "Correre la lista di controllo creata",
    "activity_updated_checklist_run": "Esegui la lista di controllo aggiornata",
    "activity_archived_checklist_run": "Esegui la lista di controllo archiviata",
    "activity_cancelled_checklist_run": "Cancellazione della lista di controllo",
    "activity_completed_checklist_run": "Correre la lista di controllo completata",
    "activity_item_added_checklist_run": "Articolo Aggiunto checklist run",
    "activity_item_updated_checklist_run": "Articolo Aggiornato checklist run",
    "activity_item_removed_checklist_run": "Articolo Rimosso checklist run",
    "activity_item_completed_checklist_run": "Articolo Completo checklist run",
    "activity_schedule_recalculated_checklist_run": "Orari Ricalcolato checklist run",
    "activity_scheduled_run_created_checklist_run": "Esegui la lista di controllo creata",
    "activity_incident_created_checklist_template": "Incident Creato modello di checklist",
    "activity_incident_updated_checklist_template": "Modello di checklist aggiornato incidente",
    "activity_incident_closed_checklist_template": "Incident Modello di checklist chiuso",
    "activity_certification_created_checklist_template": "Certificazione Creato modello di checklist",
    "activity_certification_updated_checklist_template": "Certificazione Modello di checklist aggiornato",
    "activity_certification_archived_checklist_template": "Certificazione Modello di checklist archiviato",
    "activity_person_added_checklist_template": "Persona Aggiunto modello di lista di controllo",
    "activity_person_updated_checklist_template": "Modello della lista di controllo aggiornato della persona",
    "activity_person_removed_checklist_template": "Modello di checklist rimosso dalla persona",
    "activity_witness_added_checklist_template": "Witness Aggiunto modello di lista di controllo",
    "activity_witness_updated_checklist_template": "Witness Modello di checklist aggiornato",
    "activity_witness_removed_checklist_template": "Witness modello di checklist rimosso",
    "activity_action_added_checklist_template": "Azione Aggiunto modello di lista di controllo",
    "activity_action_updated_checklist_template": "Azione Aggiornato modello della lista di controllo",
    "activity_action_cancelled_checklist_template": "Azione Cancellato modello di lista di controllo",
    "activity_attachment_added_checklist_template": "Attaccamento Aggiunto modello di lista di controllo",
    "activity_attachment_uploaded_checklist_template": "Attaccamento Caricato modello di checklist",
    "activity_attachment_removed_checklist_template": "Attaccamento Rimuovi modello di lista di controllo",
    "activity_created_checklist_template": "Creato modello di checklist",
    "activity_updated_checklist_template": "Modello di checklist aggiornato",
    "activity_archived_checklist_template": "Modello di checklist archiviato",
    "activity_cancelled_checklist_template": "Modello di checklist cancellata",
    "activity_completed_checklist_template": "Modello di checklist completo",
    "activity_item_added_checklist_template": "Articolo Aggiunto modello di lista di controllo",
    "activity_item_updated_checklist_template": "Articolo Aggiornato modello della lista di controllo",
    "activity_item_removed_checklist_template": "Oggetto Rimosso modello di checklist",
    "activity_item_completed_checklist_template": "Oggetto Modello di checklist completo",
    "activity_schedule_recalculated_checklist_template": "Pianifica modello di checklist ricalcolato",
    "activity_scheduled_run_created_checklist_template": "Programmato Esegui Creato modello di checklist",
    "activity_incident_created_risk_assessment": "Incident Creata valutazione del rischio",
    "activity_incident_updated_risk_assessment": "Valutazione del rischio aggiornata dell'incidente",
    "activity_incident_closed_risk_assessment": "Valutazione del rischio chiusa",
    "activity_certification_created_risk_assessment": "Certificazione Creata valutazione del rischio",
    "activity_certification_updated_risk_assessment": "Certificazione Valutazione del rischio aggiornata",
    "activity_certification_archived_risk_assessment": "Certificazione Valutazione del rischio archiviata",
    "activity_person_added_risk_assessment": "Valutazione del rischio",
    "activity_person_updated_risk_assessment": "Valutazione del rischio aggiornato della persona",
    "activity_person_removed_risk_assessment": "Rimozione della valutazione del rischio",
    "activity_witness_added_risk_assessment": "Witness Aggiunta valutazione del rischio",
    "activity_witness_updated_risk_assessment": "Testimonianza Valutazione del rischio aggiornata",
    "activity_witness_removed_risk_assessment": "Testimonianza Rimozione della valutazione del rischio",
    "activity_action_added_risk_assessment": "Azione Aggiunta valutazione del rischio",
    "activity_action_updated_risk_assessment": "Azione Valutazione del rischio aggiornata",
    "activity_action_cancelled_risk_assessment": "Azione Annullamento della valutazione del rischio",
    "activity_attachment_added_risk_assessment": "Aggiunta valutazione del rischio",
    "activity_attachment_uploaded_risk_assessment": "Attaccamento Valutazione del rischio",
    "activity_attachment_removed_risk_assessment": "Attaccamento Rimozione della valutazione del rischio",
    "activity_created_risk_assessment": "Valutazione del rischio creata",
    "activity_updated_risk_assessment": "Valutazione del rischio aggiornata",
    "activity_archived_risk_assessment": "Valutazione del rischio archiviata",
    "activity_cancelled_risk_assessment": "Valutazione del rischio cancellata",
    "activity_completed_risk_assessment": "Valutazione completa del rischio",
    "activity_item_added_risk_assessment": "Valutazione del rischio aggiunto",
    "activity_item_updated_risk_assessment": "Oggetto Valutazione del rischio aggiornata",
    "activity_item_removed_risk_assessment": "Oggetto Rimozione della valutazione del rischio",
    "activity_item_completed_risk_assessment": "Oggetto Valutazione completa del rischio",
    "activity_schedule_recalculated_risk_assessment": "Pianifica Ricalcolata valutazione del rischio",
    "activity_scheduled_run_created_risk_assessment": "Correre pianificata Valutazione del rischio Creata",
    "activity_incident_created_safety_document": "Incident Creato documento di sicurezza",
    "activity_incident_updated_safety_document": "Documento di sicurezza aggiornato dell'incidente",
    "activity_incident_closed_safety_document": "Documento di sicurezza chiuso dell'incidente",
    "activity_certification_created_safety_document": "Certificazione Documento di sicurezza creato",
    "activity_certification_updated_safety_document": "Certificazione Documento di sicurezza aggiornato",
    "activity_certification_archived_safety_document": "Certificazione Documento di sicurezza archiviato",
    "activity_person_added_safety_document": "Persona Aggiunto documento di sicurezza",
    "activity_person_updated_safety_document": "Documento di sicurezza aggiornato della persona",
    "activity_person_removed_safety_document": "Documento di sicurezza rimosso dalla persona",
    "activity_witness_added_safety_document": "Witness Aggiunto documento di sicurezza",
    "activity_witness_updated_safety_document": "Testimonianza Documento di sicurezza aggiornato",
    "activity_witness_removed_safety_document": "Testimonianza documento di sicurezza rimosso",
    "activity_action_added_safety_document": "Azione Documento di sicurezza aggiunto",
    "activity_action_updated_safety_document": "Azione Documento di sicurezza aggiornato",
    "activity_action_cancelled_safety_document": "Documento di sicurezza annullato",
    "activity_attachment_added_safety_document": "Attaccamento Aggiunto documento di sicurezza",
    "activity_attachment_uploaded_safety_document": "Documento di sicurezza caricato",
    "activity_attachment_removed_safety_document": "Attaccamento documento di sicurezza rimosso",
    "activity_created_safety_document": "Documento di sicurezza creato",
    "activity_updated_safety_document": "Documento di sicurezza aggiornato",
    "activity_archived_safety_document": "Documento di sicurezza archiviato",
    "activity_cancelled_safety_document": "Documento di sicurezza annullato",
    "activity_completed_safety_document": "Documento di sicurezza completo",
    "activity_item_added_safety_document": "Articolo documento di sicurezza aggiunto",
    "activity_item_updated_safety_document": "Articolo Documento di sicurezza aggiornato",
    "activity_item_removed_safety_document": "Oggetto Documento di sicurezza rimosso",
    "activity_item_completed_safety_document": "Oggetto Documento di sicurezza completo",
    "activity_schedule_recalculated_safety_document": "Documento di sicurezza ricalcolato",
    "activity_scheduled_run_created_safety_document": "Programmato Run Documento di sicurezza Creato",
    "activity_incident_closed": "Incidente chiuso",
    "activity_incident_created": "Incidente creato",
    "activity_certification_updated": "Certificazione aggiornata",
    "activity_checklist_completed": "Elenco di controllo completato",
    "activity_checklist_run_created": "Esecuzione della checklist creata",
    "activity_risk_assessment_updated": "Valutazione del rischio aggiornata",
    "activity_document_archived": "Documenti archiviati",
    "activity_document_uploaded": "Documenti caricati"
  },
  "reminders": {
    "recipient": "là.",
    "subject": "Elenco di controllo per domani: {name}",
    "hello": "Ciao {name},",
    "checklist": "Lista di controllo: {name}",
    "due": "A causa: {date}",
    "area": "Area/dipartimento: {area}",
    "category": "Categoria: {category}",
    "instructions": "Questa lista di controllo è a breve. Si prega di completare nel portale Privana e fare riferimento alla lista di controllo record per i dettagli completi.",
    "openLink": "Lista di controllo aperta Privana: {url}",
    "open": "Lista di controllo aperta Privana",
    "logo": "Logo Club",
    "dueSentence": "{name} è dovuto {date} .",
    "title": "Elenco di controllo per domani",
    "body": "{name} è dovuto {date} . Aperto Privana per completarlo."
  }
};
